import React from "react";
import styled from "styled-components";
import { ClockContext } from "../../contexts/ClockContext";
import { useContext } from "react";
import { ScrollBar } from "../../Theme/Hyper";
import { GraphicsContext } from "../../contexts/GraphicsContext";

const Button = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #181d25;
  min-height: 50px;
  width: 90%;
  box-sizing: border-box;
  border-radius: 4px;
  margin-top: 1em;
  justify-content: center;
  align-items: center;
  padding: 0.2em;
  cursor: pointer;
  :hover {
    background-color: #db0a41;
  }
`;
const Title = styled.div`
  display: flex;
  justify-content: cetner;
`;
const Caption = styled.div`
  display: flex;
  justify-content: center;
  font-size: 0.8em;
  text-align: center;
`;
const GraphicsList = styled(ScrollBar)`
  display: flex;
  flex-direction: column;
  max-height: 560px;
  overflow-y: auto;
  width: 100%;
  align-items: center;
`;

const SplitGraphicButton = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) =>
    props.green ? "#0adb93" : props.red ? "#db0a41" : "#181d25"};
  color: ${(props) => (props.green ? "#1d1d1d" : "")};
  min-height: 40px;
  width: 45%;
  box-sizing: border-box;
  border-radius: 4px;
  margin-top: 1em;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  :hover {
    background-color: ${(props) =>
      props.green ? "#0adb93" : props.red ? "#db0a41" : "#db0a41"};
  }
`;
const Row = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-evenly;
`;
export default function PlayerSky({
  player,
  previewGraphic,
  game,
  period,
  home_captains,
  away_captains,
}) {
  const { clockType } = useContext(ClockContext);
  const { graphics } = useContext(GraphicsContext);
  return (
    <GraphicsList>
      <Row>
        <SplitGraphicButton
          onClick={() => {
            previewGraphic("Name", {
              player: player,
              subtext: player?.team?.name,

              team: player?.team,
              game,
              show_number: true,
              push_up:
                graphics?.find((g) => g?.name === "CLOCK")?.onAir ||
                graphics?.find((g) => g?.name === "ScoreBug")?.onAir,
            });
          }}
        >
          Name
        </SplitGraphicButton>
        <SplitGraphicButton
          style={{ fontSize: "14px" }}
          onClick={() => {
            previewGraphic("Name", {
              player: player,
              subtext: player?.team?.name,

              team: player?.team,
              game,
              show_number: false,
              push_up:
                graphics?.find((g) => g?.name === "CLOCK")?.onAir ||
                graphics?.find((g) => g?.name === "ScoreBug")?.onAir,
            });
          }}
        >
          Name - No number
        </SplitGraphicButton>
      </Row>
      {player.captain && (
        <Row>
          <SplitGraphicButton
            onClick={() => {
              let captain = " Captain";
              if (game?.home_team?._id === player?.team?._id) {
                if (home_captains?.length > 1) {
                  captain = " Co-Captain";
                }
              } else if (game?.away_team?._id === player?.team?._id) {
                if (away_captains?.length > 1) {
                  captain = " Co-Captain";
                }
              }
              previewGraphic("Name", {
                player: player,
                subtext: player?.team?.name + captain,
                team: player?.team,
                game,
                show_number: true,
                push_up:
                  graphics?.find((g) => g?.name === "CLOCK")?.onAir ||
                  graphics?.find((g) => g?.name === "ScoreBug")?.onAir,
              });
            }}
          >
            Captain
          </SplitGraphicButton>
          <SplitGraphicButton
            style={{ fontSize: "14px" }}
            onClick={() => {
              let captain = " Captain";
              if (game?.home_team?._id === player?.team?._id) {
                if (home_captains?.length > 1) {
                  captain = " Co-Captain";
                }
              } else if (game?.away_team?._id === player?.team?._id) {
                if (away_captains?.length > 1) {
                  captain = " Co-Captain";
                }
              }
              previewGraphic("Name", {
                player: player,
                subtext: player?.team?.name + captain,
                team: player?.team,
                game,
                show_number: false,
                push_up:
                  graphics?.find((g) => g?.name === "CLOCK")?.onAir ||
                  graphics?.find((g) => g?.name === "ScoreBug")?.onAir,
              });
            }}
          >
            Captain - No number
          </SplitGraphicButton>
        </Row>
      )}
      <Row>
        <SplitGraphicButton
          onClick={() => {
            previewGraphic("NameTag", {
              player: player,
              subtext: player?.team?.name,

              team: player?.team,
              game,
              show_number: false,
              push_up:
                graphics?.find((g) => g?.name === "CLOCK")?.onAir ||
                graphics?.find((g) => g?.name === "ScoreBug")?.onAir,
            });
          }}
        >
          Name - Tag
        </SplitGraphicButton>
        <SplitGraphicButton
          onClick={() => {
            previewGraphic("POTM", {
              player: player,
              subtext:
                game?.competition?.variables?.player_of_the_match_text ||
                "Betfred Player of the Match",
              team: player?.team,
              game,
              show_number:
                window.ENV?.REACT_APP_SKY !== "true" &&
                process.env.REACT_APP_SKY !== "true"
                  ? false
                  : true,
              push_up:
                graphics?.find((g) => g?.name === "CLOCK")?.onAir ||
                graphics?.find((g) => g?.name === "ScoreBug")?.onAir,
            });
          }}
        >
          PotM
        </SplitGraphicButton>
      </Row>
      <Row>
        <SplitGraphicButton
          onClick={() => {
            previewGraphic("CLOCKSINBIN", {
              player,
              cardType: 1,
              team: player?.team,
              game,
              show_number:
                window.ENV?.REACT_APP_SKY !== "true" &&
                process.env.REACT_APP_SKY !== "true"
                  ? false
                  : true,
            });
          }}
        >
          Clock Sin bin
        </SplitGraphicButton>
        <SplitGraphicButton
          onClick={() => {
            previewGraphic("CLOCKREDCARD", {
              player,
              cardType: 1,
              team: player?.team,
              game,
              show_number:
                window.ENV?.REACT_APP_SKY !== "true" &&
                process.env.REACT_APP_SKY !== "true"
                  ? false
                  : true,
            });
          }}
        >
          Clock Sent off
        </SplitGraphicButton>
      </Row>
      <Row>
        <SplitGraphicButton
          onClick={() => {
            previewGraphic("LTSINBIN", {
              player,
              cardType: 1,
              team: player?.team,
              game,
              show_number:
                window.ENV?.REACT_APP_SKY !== "true" &&
                process.env.REACT_APP_SKY !== "true"
                  ? false
                  : true,
              push_up:
                graphics?.find((g) => g?.name === "CLOCK")?.onAir ||
                graphics?.find((g) => g?.name === "ScoreBug")?.onAir,
            });
          }}
        >
          Sin bin
        </SplitGraphicButton>
        <SplitGraphicButton
          onClick={() => {
            previewGraphic("LTREDCARD", {
              player,
              cardType: 1,
              team: player?.team,
              game,
              show_number:
                window.ENV?.REACT_APP_SKY !== "true" &&
                process.env.REACT_APP_SKY !== "true"
                  ? false
                  : true,
              push_up:
                graphics?.find((g) => g?.name === "CLOCK")?.onAir ||
                graphics?.find((g) => g?.name === "ScoreBug")?.onAir,
            });
          }}
        >
          Sent off
        </SplitGraphicButton>
      </Row>
      <Row>
        <SplitGraphicButton
          onClick={() => {
            previewGraphic("LTONREPORT", {
              player,
              cardType: 1,
              team: player?.team,
              game,
              show_number:
                window.ENV?.REACT_APP_SKY !== "true" &&
                process.env.REACT_APP_SKY !== "true"
                  ? false
                  : true,
              push_up:
                graphics?.find((g) => g?.name === "CLOCK")?.onAir ||
                graphics?.find((g) => g?.name === "ScoreBug")?.onAir,
            });
          }}
        >
          On report
        </SplitGraphicButton>
        <SplitGraphicButton
          style={{ fontSize: "14px" }}
          onClick={() => {
            previewGraphic("LTSINBIN", {
              player,
              cardType: 1,
              team: player?.team,
              game,
              countdown: true,
              clockType,
              show_number:
                window.ENV?.REACT_APP_SKY !== "true" &&
                process.env.REACT_APP_SKY !== "true"
                  ? false
                  : true,
              push_up:
                graphics?.find((g) => g?.name === "CLOCK")?.onAir ||
                graphics?.find((g) => g?.name === "ScoreBug")?.onAir,
            });
          }}
        >
          Sin bin Countdown
        </SplitGraphicButton>
      </Row>

      {(window.ENV?.REACT_APP_SKY === "true" ||
        process.env.REACT_APP_SKY === "true") && (
        <Button
          onClick={() => {
            try {
              let scorers = (game?.home_scorers || [])?.concat(
                game?.away_scorers || [],
              );
              let made =
                scorers?.filter((g) => {
                  return (
                    g.player &&
                    player.squad &&
                    g?.player === player?.squad?._id &&
                    (g?.type === "conversion" || g?.type === "penalty_kick")
                  );
                })?.length || 0;
              let missed =
                scorers?.filter((g) => {
                  return (
                    g.player &&
                    player.squad &&
                    g?.player === player?.squad?._id &&
                    (g?.type === "missed_conversion" ||
                      g?.type === "missed_penalty_kick")
                  );
                })?.length || 0;
              let player_stats = game?.opta_home_player_stats?.find(
                (p) => p?.player === player.squad?.player?.opta_ID,
              );
              if (!player_stats || player_stats?.length === 0) {
                player_stats = game?.opta_away_player_stats?.find(
                  (p) => p?.player === player.squad?.player?.opta_ID,
                );
              }
              let stats = [];
              if (made + missed > 0) {
                stats.push({
                  name: "Goal kicking",
                  value: made + "/" + (made + missed),
                });
              }
              if (parseInt(player_stats?.stats?.drop_goals) > 0) {
                stats.push({
                  name: "Drop goals",
                  value: player_stats?.stats?.drop_goals,
                });
              }
              if (parseInt(player_stats?.stats?.forty_twenty) > 0) {
                stats.push({
                  name: "40/20s",
                  value: player_stats?.stats?.forty_twenty,
                });
              }
              stats.push({
                name: "Kicks in general play",
                value: player_stats?.stats?.kicks_in_gen_play,
              });
              stats.push({
                name: "Attacking kicks",
                value: player_stats?.stats?.attacking_kicks,
              });
              stats.push({
                name: "Kick from hand metres",
                value: (player_stats?.stats?.kick_from_hand_metres ?? 0) + "m",
              });
              previewGraphic("PLAYERCB", {
                player,
                game,
                team: game?.opta_home_player_stats?.find(
                  (p) => p?.player === player.squad?.player?.opta_ID,
                )
                  ? game?.home_team
                  : game?.away_team,
                subline: "Kicking stats",
                stats,
                push_up:
                  graphics?.find((g) => g?.name === "CLOCK")?.onAir ||
                  graphics?.find((g) => g?.name === "ScoreBug")?.onAir,
              });
            } catch (err) {}
          }}
        >
          Kicking profile
        </Button>
      )}
      {(window.ENV?.REACT_APP_SKY === "true" ||
        process.env.REACT_APP_SKY === "true") && (
        <Button
          onClick={() => {
            try {
              let player_stats = game?.opta_home_player_stats?.find(
                (p) => p?.player === player.squad?.player?.opta_ID,
              );
              if (!player_stats || player_stats?.length === 0) {
                player_stats = game?.opta_away_player_stats?.find(
                  (p) => p?.player === player.squad?.player?.opta_ID,
                );
              }
              let stats = [];
             if (player_stats?.stats?.attacking_kicks > 0){
              stats.push({
                name: "Attacking kicks",
                value: player_stats?.stats?.attacking_kicks,
              });
            }
             if (player_stats?.stats?.bombKicks > 0){
              stats.push({
                name: "Bomb kicks",
                value: player_stats?.stats?.bombKicks,
              });
            }
               if (player_stats?.stats?.grubberKick > 0){
                  stats.push({
                name: "Grubber kicks",
                value: player_stats?.stats?.grubberKick,
              });
            }
               if (player_stats?.stats?.chipKick > 0){
                   stats.push({
                name: "Chip kicks",
                value: player_stats?.stats?.chipKick,
              });
            }
               if (player_stats?.stats?.crossFieldKick > 0){
                   stats.push({
                name: "Cross-field kick",
                value: player_stats?.stats?.crossFieldKick,
              });
            }
                    stats.push({
                name: "Kicked dead",
                value: player_stats?.stats?.kickDead,
              });
              previewGraphic("PLAYERCB", {
                player,
                game,
                team: game?.opta_home_player_stats?.find(
                  (p) => p?.player === player.squad?.player?.opta_ID,
                )
                  ? game?.home_team
                  : game?.away_team,
                subline: "Kicks breakdown",
                stats,
                push_up:
                  graphics?.find((g) => g?.name === "CLOCK")?.onAir ||
                  graphics?.find((g) => g?.name === "ScoreBug")?.onAir,
              });
            } catch (err) {}
          }}
        >
          Kick types
        </Button>
      )}
      {player?.type !== "coach" &&
        player?.squad?.stories &&
        player?.squad?.stories.map((stat) => {
          return (
            <Button
              onClick={() => {
                previewGraphic("Name", {
                  team: player?.team,
                  player: player,
                  subtext: stat.story,
                  line_1: stat?.line_1,
                  line_2: stat?.line_2,
                  shirt_number: player.shirt_number || "",
                  game,
                  show_number:
                    window.ENV?.REACT_APP_SKY !== "true" &&
                    process.env.REACT_APP_SKY !== "true"
                      ? false
                      : true,
                  push_up:
                    graphics?.find((g) => g?.name === "CLOCK")?.onAir ||
                    graphics?.find((g) => g?.name === "ScoreBug")?.onAir,
                });
              }}
            >
              <Caption>
                {stat.line_1} {stat.line_2}
              </Caption>
            </Button>
          );
        })}

      {/* <Row>
        <Button
          onClick={() => {
            previewGraphic("PlayerKeyStats", {
              player: player,
              subtext: player?.team?.name,
              team: player?.team,
              game,
              show_number: true,
              type: "attack",
            });
          }}
        >
          L3 key att. stats
        </Button>
      </Row>
      <Row>
        <Button
          onClick={() => {
            previewGraphic("PlayerKeyStats", {
              player: player,
              subtext: player?.team?.name,
              team: player?.team,
              game,
              show_number: true,
              type: "defence",
            });
          }}
        >
          L3 key def. stats
        </Button>
      </Row> */}
    </GraphicsList>
  );
}
